import { defineMessages } from 'react-intl'

const scope = `procurify.modules.vendor.features.create-credit-card-provider.views.credit-card-provider-inline-create-view`

export default defineMessages({
  nameLabel: {
    id: `${scope}.nameLabel`,
    defaultMessage: 'New provider name',
  },
  namePlaceholder: {
    id: `${scope}.namePlaceholder`,
    defaultMessage: 'Enter provider name',
  },
  createButton: {
    id: `${scope}.createButton`,
    defaultMessage: 'Create',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
})
